import {Layout, LayoutChild} from "../../../../../palette/Palette";
import Text from "../../../../../palette/Text";
import Invoice from "../Invoice";
import {useEffect, useState} from "react";
import {Button} from "devextreme-react/button";
import DashedLine from "../../../../../palette/DashedLine";
import VerticalSpace from "../../../../../palette/VerticalSpace";
import Alerts from "../../../../../palette/Alerts";
import {customScroll} from "../../../../../utils/Scroll";
import {Element} from 'react-scroll'
import ComponentLoadPanel from "../../../../../palette/LoadPanel";
import {useHistory} from 'react-router-dom';
import format from 'date-fns/format';
import {generateUUID} from "../../../../../utils/HelpFunctions";
import {es} from "date-fns/locale";
import {NotiStackInfo, ErrorMessage} from "../../../../../palette/NotiStackInfo";
import axios from 'axios';
import {useSnackbar} from "notistack";


const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
};

//const url = 'http://localhost:8081/express';

const url = 'https://express-easi4xatjq-uc.a.run.app/express';

function Details(props) {

    const {
        dataExpress, dataPassengers, getCoordsClient, DataStore, providerPercentage, tripStartControl, contactNumbers,
    } = props;


    const {companyName, idCompany} = DataStore
    const logoUrl = DataStore.imageAsUrl;

    const [showPanel, setShowPanel] = useState(false);
    const [invoice, setInvoice] = useState({
        name: `${dataPassengers.name} ${dataPassengers.lastName}`,
        RUC: dataPassengers.idUser,
        contactNumber: dataPassengers.contactNumber,
        email: dataPassengers.email,
        address: '',
    })

    const [popupVisible, setPopupVisible] = useState(false);
    const [success, setSuccess] = useState(false);

    const passenger = `Reservado por ${dataPassengers?.name} ${dataPassengers?.lastName}`
    const driver = `Conductor ${dataExpress.driversData[0].completeName} `
    const photo = dataExpress.driversData[0].profilePhoto
    const tokenPushPassenger = dataPassengers.tokenPush
    const tokenPushDriver = dataExpress.driversData[0].tokenPush

    let history = useHistory();
    const {enqueueSnackbar} = useSnackbar();

    useEffect(() => {
        setShowPanel(false)
        customScroll('bottom-element', 500)
    }, [])

    const renderCancelButton = () => {
        return (
            <Button id="cancel-button"
                    width={'auto'}
                    icon="fas fa-ban"
                    text="Cancelar viaje"
                    onClick={() => {
                        history.push('/control-panel/passengers-managements')
                    }}/>
        )
    }

    const onSaveReservation = async () => {

        const driver = dataExpress.driversData[0]
        const vehicleData = dataExpress.driversData[0].vehicleData

        const date = dataExpress.strDate.split(' ')
        const value = date[0]
        const hour = date[1]

        const dateStr = format(dataExpress.valueDate, 'yyyy-MM-dd');
        const dateArray = dateStr.split('-')
        const num = Math.floor(Math.random() * 100) + 1
        const cod = `${dateArray[1]}${dateArray[dateArray.length - 1]}${num.toString()}`

        const year = format(dataExpress.valueDate, 'yyyy');
        const month = format(dataExpress.valueDate, 'MMMM', {locale: es});

        const travelStatusUid = generateUUID();

        setShowPanel(true);

        const passenger = [{
            cod: cod,
            name: `${dataPassengers.name} ${dataPassengers.lastName}`,
            paymentValue: dataExpress.total.toFixed(2),
            contactNumber: dataPassengers.contactNumber,
            passengerUid: dataPassengers.docId,
            coords: getCoordsClient,
            paymentStatus: false,
            tokenPush: tokenPushPassenger,
            details: dataExpress.details,
            typeReservation: 'express',
        }];

        const newObject = {
            date: value,
            driver: `${driver.name} ${driver.lastName}`,
            driverId: driver.docId,
            hour: hour,
            color: vehicleData.color,
            brand: vehicleData.brand,
            type: 'express',
            typeReservation: 'manual',
            plateNumber: vehicleData.plateNumber,
            routeName: `${getCoordsClient.origenCity}-${getCoordsClient.destinyCity}`,
            passenger: passenger,
            statusTrip: false,
            tripStartControl: tripStartControl,
            providerPercentage: providerPercentage,
            travelStatusUid: travelStatusUid,
        };

        const bookingHistory = {
            cod: cod,
            date: newObject.date,
            driver: newObject.driver,
            uid: dataPassengers.docId,
            driverId: newObject.driverId,
            routeName: newObject.routeName,
            travelStatusUid: newObject.travelStatusUid,
            type: 'EX',
            typeBooking: 'M',
            numberSeats: 1,
            numberParcels: 0,
            photo: photo,
            paymentValue: dataExpress.total.toFixed(2),
            status: 'Pendiente',
            statusTrip: 'Pendiente',
            year: year,
            month: month,
            hour: hour,
            seating: [],
            passenger: `${dataPassengers.name} ${dataPassengers.lastName}`,
            origen: getCoordsClient.origenDirection,
            destination: getCoordsClient.destinationDirection,
            plateNumber: newObject.plateNumber,
            color: newObject.color,
            brand: newObject.brand,
            observation: dataExpress.details,
            wayPay: 'Efectivo',
            invoice: invoice,
            observationBooking: []
        }

        const travelStatus = {
            cod: cod,
            date: newObject.date,
            driver: newObject.driver,
            driverId: newObject.driverId,
            travelStatusUid: travelStatusUid,
            plateNumber: newObject.plateNumber,
            contactNumber: dataExpress.driversData[0].contactNumber,
            origen: getCoordsClient.origenCity,
            destination: getCoordsClient.destinyCity,
            hour: hour,
            numberPassengers: 1,
            totalParcels: 0,
            onBoard: 0,
            year: year,
            month: month,
            status: 'Pendiente',
        }

        const dataValidation = {
            cod: cod,
            date: newObject.date,
            driver: newObject.driver,
            driverId: newObject.driverId,
            routeName: newObject.routeName,
            passenger: `${dataPassengers.name} ${dataPassengers.lastName}`,
            contact: dataPassengers.contactNumber,
            tokenPush: [{key: 'Driver', token: tokenPushDriver}, {key: 'Passenger', token: tokenPushPassenger}],
            year: year,
            month: month,
            hour: hour,
            travelStatusUid: travelStatusUid,
            plateNumber: newObject.plateNumber,
            contactNumber: dataExpress.driversData[0].contactNumber,
            statusPayment: 'Pendiente',
            toMail: dataPassengers.email,
            contactNumbers: contactNumbers,
            logoUrl: logoUrl,
            color: newObject.color,
            brand: newObject.brand,
            paymentValue: dataExpress.total.toFixed(2),
        }

        const newData = {
            companyName: companyName,
            idCompany: idCompany,
            data: newObject,
            dataValidation: dataValidation,
            travelStatus: travelStatus,
            bookingHistory: bookingHistory
        };

        await axios.post(url, newData, {headers: headers})
            .then(res => {
                if (res.data === 'OK') {
                    setShowPanel(false);
                    setSuccess(true)
                    customScroll('bottom-element', 500)
                    setTimeout(() => {
                        setSuccess(false)
                        history.push('/control-panel/passengers-managements');
                    }, 2000)
                }

                if (res.data === 'NM') {
                    setShowPanel(false);
                    setSuccess(true)
                    customScroll('bottom-element', 500)
                    setTimeout(() => {
                        setSuccess(false)
                        history.push('/control-panel/passengers-managements');
                    }, 2000)
                }

                if (res.data === 'NG') {
                    setShowPanel(false);
                    setSuccess(false)
                    NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar);
                }
            }).catch(() => {
                setSuccess(false)
                setShowPanel(false);
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar);
            })
    }

    return (
        <>
            <Invoice setInvoice={setInvoice} invoice={invoice} setPopupVisible={setPopupVisible}
                     popupVisible={popupVisible}/>
            <LayoutChild center percent={100} padding={15} row color={'#EEF4FD'}>
                <LayoutChild percent={50}>
                    <Text hover={false} text={`Viaje express`} size={16} weight={'700'}/>
                    <Text hover={false} text={passenger} size={12}/>
                    <Text hover={false} text={getCoordsClient.origenCity} size={10} weight={'700'}/>
                    <Text hover={false} text={`Fecha : ${dataExpress.strDate}`} size={11} color={'gray'}
                          weight={'bold'}/>
                </LayoutChild>
                <LayoutChild percent={50} row center>
                    <Layout column>
                        <Text hover={false} text={`Destino ${getCoordsClient.destinyCity}`} size={14} weight={'700'}/>
                        <Text hover={false} text={driver} size={12}/>
                    </Layout>
                    <Button icon="far fa-file-alt" text="Factura" onClick={() => setPopupVisible(true)}/>
                </LayoutChild>
            </LayoutChild>

            <LayoutChild color={'transparent'} top={2} padding={15}>
                <DashedLine/>
                <VerticalSpace space={10}/>
                <VerticalSpace space={10}/>
                <Layout row space>
                    <Text hover={false} text={`Valor de el viaje`} size={14} weight={'700'}/>
                    <Text hover={false} text={`$ ${dataExpress.total.toFixed(2)}`} size={14} weight={'600'}/>
                </Layout>
                <VerticalSpace space={10}/>
                <DashedLine/>
                <VerticalSpace space={20}/>

                <Layout color={'transparent'} row center space>
                    <Text hover={false} size={14} text={'Forma de pago'} weight={'500'}/>
                    <Text hover={false} size={12} text={'Efectivo'} weight={'500'}/>
                    <LayoutChild color={'transparent'} row center>
                        <Text hover={false} size={14} text={'Total a pagar :'} weight={'700'}/>
                        <Text hover={false} size={14} text={`$ ${dataExpress.total.toFixed(2)}`} weight={'700'}
                              color={'#32B859'} left={7}/>
                    </LayoutChild>
                </Layout>
            </LayoutChild>
            <VerticalSpace space={15}/>
            {success && <Alerts severity={'success'} body={'Reserva generada exitosamente'}/>}
            <LayoutChild percent={100} padding={15} row positionR>
                {renderCancelButton()}
                <Button icon="far fa-check-circle" text="Crear viaje" width={150} id={'button-save'}
                        onClick={onSaveReservation} type='success'/>
            </LayoutChild>
            <Element name="bottom-element" className="element"/>
            <ComponentLoadPanel showLoadPanel={showPanel} message={'Creando viaje express...'} time={3500}/>
        </>
    )
}


export default Details